import { SupportedCities } from '../../enums';

const DEFAULT_CITY = SupportedCities.DUSSELDORF;
const CITY_COOKIE_KEY = 'city';
const IS_CITY_COOKIE_SELECTED = 'isCitySelected';

export { DEFAULT_CITY, CITY_COOKIE_KEY, IS_CITY_COOKIE_SELECTED };
